export * from './delete-objekt.component';
export * from './delete-objekt.component.module';